module.exports = __webpack_public_path__ + "./docs/img/vox-react.c60566499b0e088f23e3f00635a4a0ca.svg";